import axios, { AxiosResponse } from "axios";
import { LEAD_CREATE } from "./apis";

export const leadApi = (postData: any) => {
    return axios
      .post(`${LEAD_CREATE}`, postData)
      .then((d: AxiosResponse<any>) => d?.data);
  };